module.exports = __webpack_public_path__ + "static/media/100_6.de882536.jpg";